import React from "react";
import { motion } from "framer-motion";

// Scroll-reveal wrapper used across landing sections.
export const Reveal = ({ children, delay = 0, y = 22, className = "", once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-60px" }}
    transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1], delay }}
  >
    {children}
  </motion.div>
);
